module.exports = __webpack_public_path__ + "img/bg_01_brown_right.d250ff1d.png";